import type { GlobalAppSlug } from "@/lib/dashboardAppRegistry";
import { DASHBOARD_APP_ORDER } from "@/lib/dashboardAppRegistry";
import { ONE_INNER_APP_SLUGS } from "@/lib/atwSystemAccess";

const LEGACY_FULL_ONE_INNER: readonly Exclude<GlobalAppSlug, "home">[] = [
  "crm",
  "finance",
  "human-resources",
  "marketing",
  "knowledge",
  "projects",
  "custom-apps",
  "support",
];

export function expandStaleFullOneEntitlements(slugs: GlobalAppSlug[]): GlobalAppSlug[] {
  const set = new Set<GlobalAppSlug>(slugs);
  const hasLegacyFull = LEGACY_FULL_ONE_INNER.every((s) => set.has(s));
  if (hasLegacyFull) {
    for (const s of ONE_INNER_APP_SLUGS) set.add(s);
  }
  return DASHBOARD_APP_ORDER.filter((s) => set.has(s));
}
